import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { DeviceStoreActions } from '@era/stores';
import { Store } from '@ngrx/store';
import { DeviceSyncStatus } from '@rocksoft/apple-sync-sdk';
import { DeviceSyncStatusSelectors } from '../../../sub-features/device-sync/device-sync-statuses-store';
import { DeviceMdmSyncForceContainerComponent } from '../device-mdm-sync-force/device-mdm-sync-force.container';
import { ForceSyncService } from '../device-mdm-sync-force/device-mdm-sync-force.service';
import { DeviceMdmSyncRetryComponent } from './device-mdm-sync-retry.component';

@Component({
  selector: 'era-device-mdm-sync-retry',
  templateUrl: './device-mdm-sync-retry.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DeviceMdmSyncForceContainerComponent, DeviceMdmSyncRetryComponent],
})
export class DeviceMdmSyncRetryContainerComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly forceSyncService = inject(ForceSyncService);

  readonly deviceStatus = this.store.selectSignal(DeviceSyncStatusSelectors.selectCurrentDeviceSyncStatus);

  private forceSync = false;

  public retry(status: DeviceSyncStatus) {
    if (status?.udid !== undefined && status?.udid !== null) {
      this.store.dispatch(
        DeviceStoreActions.DeviceSyncStatusViewActions.retrySync({
          udid: status.udid,
          forceSync: this.forceSync,
        })
      );
    }
  }

  ngOnInit() {
    this.forceSyncService.forceSync$.subscribe((value) => {
      this.forceSync = value;
    });
  }
}
